module.exports = ".width50{width:50%;padding:5px}\n"